module.exports = __webpack_public_path__ + "img/didbind-loader-line.9292bf7d.png";